import { Subtitle2Text, SmallTitle } from '@/utils/global-fonts';
import { MdArrowDropDown, MdOutlineSettings } from 'react-icons/md';
import styled from 'styled-components';

const Main = styled.div`
  align-items: center;
  border-bottom-width: 0px;
  border-color: ${({ theme }) => theme.COLOR_GREY5};
  border-left-width: 1px;
  border-right-width: 1px;
  border-style: solid;
  border-top-width: 0px;
  display: flex;
  justify-content: center;
  padding-left: 30px;
  padding-right: 30px;
  cursor: pointer;
  user-select: none;
`;

const Heading = styled.div`
  align-items: center;
  border-bottom-width: 0px;
  border-color: ${({ theme }) => theme.COLOR_GREY5};
  display: flex;
  justify-content: center;
  padding-left: 30px;
  padding-right: 30px;
  cursor: pointer;
  user-select: none;
`;

const CurrencyText = styled(Subtitle2Text)`
  color: ${({ theme }) => theme.COLOR_TEXT};
`;

const DropdownIcon = styled(MdArrowDropDown)`
  color: ${({ theme }) => theme.COLOR_GREY3};
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  border-radius: 50%;
  margin-left: 6px;
  color: ${({ theme, $active }) => ($active ? theme.COLOR_TEXT : 'none')};
`;

const DropDown = styled.div`
  position: absolute;
  display: flex;
  top: 55px;
  right: 202px;
  border-radius: 4px;

  .card {
    justify-content: flex-start;
    padding: 0;
  }

  .card-item {
    height: 30px;
    text-align: left;
    background-color: white;
    border: none;
    font-size: 14px;
    white-space: nowrap;
    width: 100%;
    display: block;

    @media (hover: hover) {
      &:hover {
        background: rgba(51%, 81%, 94%, 25%);
        color: #77c3ec;
        font-weight: normal;
        cursor: pointer;
      }
    }
  }
`;

const Title = styled(SmallTitle)`
  margin-left: 6px;
`;

const DropDownHeading = styled.div`
  height: 40px;
  span {
    text-transform: uppercase;
  }
  padding: 0 16px;
`;

const GearIcon = styled(MdOutlineSettings)`
  margin-right: 15px;
  margin-left: 17px;
`;

const CurrencySymbol = styled.span`
  margin-right: 15px;
  margin-left: 17px;
`;

const Option = styled.div`
  /* user-select: ${({ $disabled }) => $disabled && 'none'}; */
  height: 40px;
  display: flex;
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  padding: 0 4px;

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.20000000298023224px;
    text-align: left;
    font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
    color: ${({ $selected, theme }) =>
      $selected ? theme.COLOR_BLACK : theme.COLOR_GREY_TEXT};
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.COLOR_GREY5};
      span {
        font-weight: 600;
        color: ${({ theme }) => theme.COLOR_BLACK};
      }

      svg {
        color: ${({ theme }) => theme.COLOR_BLACK};
      }
    }
  }
`;

const CurrencyComponentStyle = {
  Main,
  CurrencyText,
  DropdownIcon,
  DropDown,
  Title,
  DropDownHeading,
  Option,
  GearIcon,
  Heading,
  CurrencySymbol,
};

export default CurrencyComponentStyle;
